var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 2",
    viewBox: "0 0 64 64",
    id: "sun",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 16,
    x2: 48,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f42a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb92b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 29.049,
    x2: 23.344,
    y1: 26.697,
    y2: 18.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feffc0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8ff9b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 33,
    x2: 31,
    y1: 6.822,
    y2: 6.822,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 21.164,
    x2: 19.891,
    y1: 11.541,
    y2: 12.277,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 10.688,
    x2: 9.666,
    y1: 18.555,
    y2: 20.326,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 8.864,
    x2: 8.864,
    y1: 31,
    y2: 32.821,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 9.773,
    x2: 10.645,
    y1: 43.86,
    y2: 45.37,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 19.72,
    x2: 21.271,
    y1: 51.625,
    y2: 52.52,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 31,
    x2: 33,
    y1: 57.178,
    y2: 57.178,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 42.702,
    x2: 44.434,
    y1: 52.536,
    y2: 51.536,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 53.305,
    x2: 54.306,
    y1: 45.456,
    y2: 43.723,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 55.136,
    x2: 55.136,
    y1: 33,
    y2: 31,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 54.306,
    x2: 53.305,
    y1: 20.277,
    y2: 18.544,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 44.434,
    x2: 42.702,
    y1: 12.464,
    y2: 11.464,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 32,
    x2: 32,
    y1: 36,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb92b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb92b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    y1: 8,
    y2: 12.643,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(-30 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(-60 32 32.001)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(-90 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(-120 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(-150 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(180 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(150 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(120 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(90 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(60 32 32)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    y1: 8,
    y2: 12.643,
    gradientTransform: "rotate(30 32 32)",
    xlinkHref: "#b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 16,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M43.09 20.48 16.22 34.62A15.106 15.106 0 0 1 16 32a15.99 15.99 0 0 1 27.09-11.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M32 12.643a1 1 0 0 1-1-1V2a1 1 0 0 1 2 0v9.643a1 1 0 0 1-1 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M21.822 15.37a1 1 0 0 1-.867-.5l-2.778-4.813a1 1 0 1 1 1.732-1l2.779 4.813a1 1 0 0 1-.866 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M14.37 22.821a.997.997 0 0 1-.5-.134l-8.351-4.82a1 1 0 1 1 1-1.733l8.351 4.821a1 1 0 0 1-.501 1.866Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M11.643 33H6.086a1 1 0 0 1 0-2h5.557a1 1 0 1 1 0 2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M6.02 48a1 1 0 0 1-.501-1.866l8.351-4.822a1 1 0 1 1 1 1.733l-8.351 4.821A.997.997 0 0 1 6.02 48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M19.042 55.442a1 1 0 0 1-.865-1.5l2.778-4.812a1 1 0 0 1 1.733 1l-2.779 4.813a1 1 0 0 1-.867.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M32 63a1 1 0 0 1-1-1v-9.643a1 1 0 1 1 2 0V62a1 1 0 0 1-1 1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M44.958 55.442a1 1 0 0 1-.867-.5l-2.779-4.812a1 1 0 1 1 1.733-1l2.778 4.813a1 1 0 0 1-.865 1.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M57.98 48a.997.997 0 0 1-.499-.134l-8.351-4.821a1 1 0 0 1 1-1.733l8.351 4.822A1 1 0 0 1 57.98 48Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M57.914 33h-5.557a1 1 0 1 1 0-2h5.557a1 1 0 0 1 0 2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M49.63 22.821a1 1 0 0 1-.5-1.866l8.351-4.821a1 1 0 1 1 1 1.732l-8.351 4.822a.997.997 0 0 1-.5.133Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M42.178 15.37a1 1 0 0 1-.865-1.5l2.778-4.813a1 1 0 1 1 1.732 1l-2.778 4.813a1 1 0 0 1-.867.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M16.527 36a15.976 15.976 0 0 0 30.946 0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M31 8v3.643a1 1 0 1 0 2 0V8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m19.134 11.715 1.821 3.155a1 1 0 0 0 1.733-1l-1.822-3.155Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m10.715 20.866 3.155 1.822a1 1 0 0 0 1-1.732l-3.155-1.822Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M8 33h3.643a1 1 0 1 0 0-2H8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m11.715 44.866 3.155-1.821a1 1 0 0 0-1-1.733l-3.155 1.822Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "m20.866 53.285 1.822-3.155a1 1 0 0 0-1.732-1l-1.822 3.155Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M33 56v-3.643a1 1 0 1 0-2 0V56Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "m44.866 52.285-1.822-3.155a1 1 0 0 0-1.732 1l1.822 3.155Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m53.285 43.134-3.155-1.822a1 1 0 0 0-1 1.732l3.155 1.822Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M56 31h-3.643a1 1 0 1 0 0 2H56Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m52.285 19.134-3.155 1.822a1 1 0 0 0 1 1.732l3.155-1.822Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "m43.134 10.715-1.822 3.155a1 1 0 0 0 1.732 1l1.822-3.155Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.089be3b9589afcfcb531991132004d79.svg";
export { ForwardRef as ReactComponent };